module.exports = __webpack_public_path__ + "img/train-3.e5f39c34.jpg";